"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const include_1 = require("./include");
const constant_1 = require("./expression/constant");
class TwingNodeEmbed extends include_1.TwingNodeInclude {
    // we don't inject the module to avoid node visitors to traverse it twice (as it will be already visited in the main module)
    constructor(name, index, variables, only, ignoreMissing, lineno, columnno, tag) {
        super(new constant_1.TwingNodeExpressionConstant('not_used', lineno, columnno), variables, only, ignoreMissing, lineno, columnno, tag);
        this.setAttribute('name', name);
        this.setAttribute('index', index);
    }
    addGetTemplate(compiler) {
        compiler
            .raw('this.loadTemplate(')
            .string(this.getAttribute('name'))
            .raw(', ')
            .repr(this.getTemplateName())
            .raw(', ')
            .repr(this.getTemplateLine())
            .raw(', ')
            .string(this.getAttribute('index'))
            .raw(')');
    }
}
exports.TwingNodeEmbed = TwingNodeEmbed;
